module.exports = __webpack_public_path__ + "img/cockpit.0ae8434d.jpeg";